import { useMemo } from 'react';

/**
 * Resolve a CSS custom property (defined by the active theme class on <html>,
 * e.g. .blueberry / .jade / .mexican) to a concrete #rrggbb hex string.
 *
 * Why hex: hex-based consumers such as GreenSubmitButton build an MUI
 * createTheme({ palette }) and run hex math (adjustColor) — both choke on a
 * raw `var(--x)` string. Reading the live computed value lets the color follow
 * the active theme while staying a parseable hex.
 *
 * THEME is a per-deployment build constant (window.THEME), so the resolved
 * value is stable for the session — memoised on the variable name.
 */
export default function useThemeColor(varName, fallback = '#2E7D32') {
  return useMemo(() => {
    try {
      const raw = getComputedStyle(document.documentElement)
        .getPropertyValue(varName)
        .trim();
      if (!raw) return fallback;
      // Normalise any valid CSS color (hsl/rgb/named/hex) to #rrggbb.
      const ctx = document.createElement('canvas').getContext('2d');
      ctx.fillStyle = raw;
      return ctx.fillStyle;
    } catch (e) {
      return fallback;
    }
  }, [varName, fallback]);
}
